import { AppContext } from "App";

import { DataSourceException } from "Global/Base/Exceptions";
import { OWExceptions } from "OW.Remoting/Basic/OWExceptions";
import { ErrorHandler } from "UI/Errors";

/**
 * Třída strající se o zpracování chyb
 * @includeToDoc
 */
export class DataSourceErrorHandler {
    /**
     * Zpracuje a zobrazí odpovídající hlášku při selhání načítání dat
     * @param error Nastalá chyba
     * @param hasFilterCondition Zda je aktivní filtr
     */
    public static handleDataSourceError(error: any, hasFilterCondition: boolean): void {
        try {
            const errData = OWExceptions.parseJSON(error);
            ErrorHandler.instance.handleError(errData);
        } catch (e) {
            if (AppContext.instance.configuration.developmentMode) {
                ErrorHandler.instance.handleError(error);
            } else {
                ErrorHandler.instance.handleError(new DataSourceException(hasFilterCondition));
            }
        }
    }
}
